import React, { useEffect, useState } from 'react';
import { HiOutlineEye, HiOutlineEyeOff } from 'react-icons/hi';
import { IPrimaryInput } from '../../interfaces/components/input.interface';

const PrimaryInput: React.FC<IPrimaryInput> = ({
  type = 'text',
  icon,
  desc,
  classname,
  pattern = '',
  setValue,
  value,
  sideComponents,
  error = false,
  inputName,
  isObject = false,
  disabled = false,
  currentRef,
  onBlur,
  iconClass,
  readOnly = false,
  maxLength,
}) => {
  const [inputType, setType] = useState<string>(type);

  useEffect(() => {
    setType(type);
  }, [type]);

  return (
    <main
      className={`${classname} ${!readOnly && 'px-3'} border ${
        error
          ? 'border-red-500 focus-within:border-gray-300'
          : 'border-[#e2e2e2] focus-within:border-sky-500'
      } rounded-lg flex items-center justify-start gap-3 relative overflow-hidden`}
    >
      {disabled && (
        <div className="absolute z-20 w-full h-full top-0 left-0 rounded-lg bg-gray-300 opacity-30"></div>
      )}
      {icon && (
        <p
          className={`${
            iconClass || 'bg-[#2691BD1A] text-primary'
          } text-lg px-1 py-2 flex items-center rounded-md`}
        >
          {icon}
        </p>
      )}
      <input
        onBlur={onBlur}
        ref={currentRef}
        pattern={pattern}
        type={inputType}
        maxLength={maxLength || 256}
        name={(inputName && inputName) || ''}
        onChange={(e) => {
          isObject
            ? setValue(e.target.name, e.target.value)
            : setValue(e.target.value);
        }}
        className={`bg-transparent focus:outline-none flex-1 py-3 placeholder:text-[#C4C4C4] placeholder:font-light ${
          value == ''
            ? 'text-grey_2'
            : readOnly
            ? 'text-gray-400'
            : 'text-black'
        } ${readOnly && 'bg-[#F1F2F3] px-3'}`}
        placeholder={desc}
        value={value}
        readOnly={readOnly}
      />
      {sideComponents}
      {type == 'password' && (
        <div
          className="cursor-pointer"
          onClick={() => setType(inputType == 'password' ? 'text' : 'password')}
        >
          {inputType == 'password' ? <HiOutlineEye /> : <HiOutlineEyeOff />}
        </div>
      )}
    </main>
  );
};

export default PrimaryInput;
